import api from './api';

const POSTS_CHANGED_EVENT = 'intranet:postsChanged';
const emitPostsChanged = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(POSTS_CHANGED_EVENT));
};

export interface Event {
  id: string;
  title: string;
  eventDate: string;
  eventTime?: string;
  description?: string;
  displayOrder: number;
  imageUrl?: string;
  postId?: string;
  /** API/DB may send boolean or 0/1 */
  isNewEmployee?: boolean | number;
  employeeName?: string;
  employeeDepartment?: string;
  createdBy?: {
    id: string;
    fullName: string;
  };
  createdAt: string;
  updatedAt: string;
}

export const eventsService = {
  async getAll(): Promise<Event[]> {
    const response = await api.get('/events');
    return response.data;
  },

  async getUpcoming(): Promise<Event[]> {
    const response = await api.get('/events/upcoming');
    return response.data;
  },

  async getById(id: string): Promise<Event> {
    const response = await api.get(`/events/${id}`);
    return response.data;
  },

  async uploadImage(data: FormData): Promise<{ url: string }> {
    const response = await api.post('/events/upload', data);
    return response.data;
  },

  async create(data: {
    title: string;
    eventDate: string;
    eventTime?: string;
    description?: string;
    displayOrder?: number;
    imageUrl?: string;
    shouldNotify?: boolean;
  }): Promise<Event> {
    const response = await api.post('/events', data);
    emitPostsChanged();
    return response.data;
  },

  async update(id: string, data: Partial<Event>): Promise<Event> {
    const response = await api.patch(`/events/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/events/${id}`);
  },
};
